import request from "../utils/request";
import { getRamdomNum } from "../utils/index";
import { resolveAIWorkflowUrl } from "../utils/aiWorkflow";

export function Api_AutoReply(data) {
  // return request({
  //   url: "/strategy/auto-reply",
  //   method: "post",
  //   data,
  // });
}
export function Api_ResetAutoReply(params) {
  // return request({
  //   url: "/strategy/reset-auto-reply",
  //   method: "get",
  //   params,
  // });
}
export function Api_OnlineHeart(data) {
  // return request({
  //   url: "/online/heart",
  //   method: "post",
  //   data,
  // });
}

export function Api_AiChat(data) {
  // let sign_num = getRamdomNum(1000, 9999);
  // return request({
  //   // baseURL: "https://test-im.yay.chat/tolink_api/v1/host_api",
  //   baseURL: import.meta.env.VITE_BASE_AI_URL,
  //   headers: {
  //     AI_SK: btoa(sign_num + sessionStorage.getItem("tolink_token")),
  //     AI_SK_SIGN: sign_num,
  //     ADMIN_LOGIN_TOKEN:
  //       "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImI1ZGE1MzRiLTFiZjctNDAwZC1hNTIzLWM2MGNiNzJlYTQwZCJ9.jwAP81F7zGzMMjc-gm0F5GIBm3WvJWjVwUelOYS6EECbu1TJz9Xnl2gU0iLuBeEr_3JAk6-iCpcSSpa2uXtm6A",
  //     ADMIN_USER_ID: "0079527",
  //     ADMIN_USER_NAME: "tolink",
  //   },
  //   url: "/ai/ai_chat",
  //   method: "post",
  //   data,
  // });
}

export function Api_AiOpenSession(data) {
  // let sign_num = getRamdomNum(1000, 9999);
  // return request({
  //   baseURL: import.meta.env.VITE_BASE_AI_URL,
  //   headers: {
  //     AI_SK: btoa(sign_num + sessionStorage.getItem("tolink_token")),
  //     AI_SK_SIGN: sign_num,
  //     ADMIN_LOGIN_TOKEN:
  //       "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImI1ZGE1MzRiLTFiZjctNDAwZC1hNTIzLWM2MGNiNzJlYTQwZCJ9.jwAP81F7zGzMMjc-gm0F5GIBm3WvJWjVwUelOYS6EECbu1TJz9Xnl2gU0iLuBeEr_3JAk6-iCpcSSpa2uXtm6A",
  //     ADMIN_USER_ID: "0079527",
  //     ADMIN_USER_NAME: "tolink",
  //   },

  //   url: "/ai/open_session",
  //   method: "post",
  //   data,
  // });
}
export function Api_AiSendMessage(data) {
  // let sign_num = getRamdomNum(1000, 9999);
  // return request({
  //   baseURL: import.meta.env.VITE_BASE_AI_URL,
  //   headers: {
  //     AI_SK: btoa(sign_num + sessionStorage.getItem("tolink_token")),
  //     AI_SK_SIGN: sign_num,
  //     ADMIN_LOGIN_TOKEN:
  //       "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImI1ZGE1MzRiLTFiZjctNDAwZC1hNTIzLWM2MGNiNzJlYTQwZCJ9.jwAP81F7zGzMMjc-gm0F5GIBm3WvJWjVwUelOYS6EECbu1TJz9Xnl2gU0iLuBeEr_3JAk6-iCpcSSpa2uXtm6A",
  //     ADMIN_USER_ID: "0079527",
  //     ADMIN_USER_NAME: "tolink",
  //   },

  //   url: "/ai/send_message",
  //   method: "post",
  //   data,
  // });
}

export function Api_AiSendChat(data) {
  let larkId = sessionStorage.getItem('.__tg.larkid');
  let larkName = sessionStorage.getItem('.__tg.larkname');
  let sign_num = getRamdomNum(1000, 9999);
  return request({
    // baseURL: import.meta.env.VITE_BASE_AI_URL_NEW,
    headers: {
      AI_SK: btoa(sign_num + sessionStorage.getItem("tolink_token")),
      AI_SK_SIGN: sign_num,
      ADMIN_LOGIN_TOKEN:
        "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImI1ZGE1MzRiLTFiZjctNDAwZC1hNTIzLWM2MGNiNzJlYTQwZCJ9.jwAP81F7zGzMMjc-gm0F5GIBm3WvJWjVwUelOYS6EECbu1TJz9Xnl2gU0iLuBeEr_3JAk6-iCpcSSpa2uXtm6A",
      ADMIN_USER_ID: "0079527",
      ADMIN_USER_NAME: "tolink",
    },

    // url: "/ai/send_chat",
    url: resolveAIWorkflowUrl(),
    method: "post",
    data,
    params: {
      larkId: larkId || "",
      larkName: larkName || "",
    }
  });
}

export function Api_AiResetSession(params) {
  // let sign_num = getRamdomNum(1000, 9999);
  // return request({
  //   baseURL: import.meta.env.VITE_BASE_AI_URL,
  //   headers: {
  //     AI_SK: btoa(sign_num + sessionStorage.getItem("tolink_token")),
  //     AI_SK_SIGN: sign_num,
  //     ADMIN_LOGIN_TOKEN:
  //       "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImI1ZGE1MzRiLTFiZjctNDAwZC1hNTIzLWM2MGNiNzJlYTQwZCJ9.jwAP81F7zGzMMjc-gm0F5GIBm3WvJWjVwUelOYS6EECbu1TJz9Xnl2gU0iLuBeEr_3JAk6-iCpcSSpa2uXtm6A",
  //     ADMIN_USER_ID: "0079527",
  //     ADMIN_USER_NAME: "tolink",
  //   },

  //   url: "/ai/reset_session",
  //   method: "get",
  //   params,
  // });
}

export function Api_TgBot_Report(data) {
  // return request({
  //   baseURL: "https://api.telegram.org",
  //   url: "/bot6447588756:AAGZy2PfqQ71bd7Im7JDCdVYY5CrXW2rBZ8/sendMessage",
  //   method: "post",
  //   data,
  // });
}

export function Api_Translate(data) {
  // return request({
  //   url: "/translate/tr",
  //   method: "get",
  //   params: data,
  // });
}

export function Api_TranslateGGToken(data) {
  // return request({
  //   url: "/translate/ggToken",
  //   method: "get",
  //   params: data,
  // });
}

export function Api_TranslateReport(data) {
  // return request({
  //   url: "/translate/report",
  //   method: "post",
  //   data,
  // });
}

export function getConfig() {
  // return request({
  //   url: "/group-member/get-config",
  //   method: "get",
  // });
}
export function getMeta(params) {
  // return request({
  //   url: "/fans/get-meta",
  //   method: "get",
  //   params,
  // });
}

// curl --location 'http://ai-api.yay.chat/api/v1/ai/query_chat_rsp?userId=22345542' \
// --header 'AI_SK: NDQwYTIyYTgtYzE2OC00MzAzLWJhMDctYzQxYzdiODI3YTJkZXlKaGJHY2lPaUpJVXpJMU5pSXNJbUZqWTI5MWJuUWlPakV3TURnNU9ERXNJblI1Y0NJNklrcFhWQ0o5LmV5SnBjM01pT2lKamFHRjBMbmxoZVNJc0ltVjRjQ0k2TVRjME5UazRNREE0TUgwLkUwa1ZjMkt5N214WTZtMTFwV3ZsXzMtM1BNRU54T0c2UWlJUmJPWFZINGs=' \
// --header 'AI_SK_SIGN: 440a22a8-c168-4303-ba07-c41c7b827a2d' \

  export function Api_AiQueryChatRsp(params) {
  // let sign_num = getRamdomNum(1000, 9999);
  // return request({
  //   baseURL: import.meta.env.VITE_BASE_AI_URL_NEW,
  //   headers: {
  //     AI_SK: btoa(sign_num + sessionStorage.getItem("tolink_token")),
  //     AI_SK_SIGN: sign_num,
  //     ADMIN_LOGIN_TOKEN:
  //       "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImI1ZGE1MzRiLTFiZjctNDAwZC1hNTIzLWM2MGNiNzJlYTQwZCJ9.jwAP81F7zGzMMjc-gm0F5GIBm3WvJWjVwUelOYS6EECbu1TJz9Xnl2gU0iLuBeEr_3JAk6-iCpcSSpa2uXtm6A",
  //     ADMIN_USER_ID: "0079527",
  //     ADMIN_USER_NAME: "tolink",
  //   },
  //   // url: "/ai/query_chat_rsp",
  //   url: "/ai/query_rsp_batch",
  //   method: "get",
  //   params,
  // });
  }
